<template>
    <div class="main" :class="homepageClass">
        <register-sub-navigation/>
        <transition>
            <div>
                <router-view/>
            </div>
        </transition>
    </div>
</template>

<script>
import RegisterSubNavigation from '@/components/structure/navigation/RegisterSubNavigation';

export default {
    name: 'Register',
    components: {
        RegisterSubNavigation,
    },
    computed: {
        loadPrimer() {
            return !this.$store.getters['localisation/isUSA'];
        },
        hasAcceptedCookies() {
            return this.$store.getters['cookies/getHasAnsweredCookieForm'];
        },
        homepageClass() {
            return !this.hasAcceptedCookies ? 'homepage-padding' : '';
        },
    },
    mounted() {
        this.$store.dispatch('cookies/mountPrimer');
        this.$store.dispatch('cookies/mountStripe');
    },
};
</script>

<style lang="scss" scoped>
    .homepage-padding {
        padding-top: 200px;
    }
</style>
